<div class="nav-container-1 project-container">

  <mat-tab-group (selectedTabChange)="tabChanged($event)">
    <mat-tab class="mat-tab-label-content" #page label="Elements-Configure">
      <!-- <div> -->
      <!-- <div style="width:100%; display:inline-block">
        <div style="width: 83%; margin-top: 1%;margin-bottom: 2%;">
          <button style="float:right;" class="btn btn-primary" (click)="AddNewData('Elements-Configure')">Elements-Configure</button>
        </div>
      </div> -->
      <div >
        <kendo-grid [kendoGridBinding]="ElementProjectlink" [sortable]="true" [resizable]="true"
          [filterable]="EC_enableFilter" [reorderable]="true" [pageSize]="15" [pageable]="true">
          <ng-template kendoPagerTemplate>
            <div class="k-pager-left">
              <kendo-pager-info></kendo-pager-info>
            </div>
            <div class="k-pager-right">
              <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
              <kendo-pager-input></kendo-pager-input>
              <kendo-pager-next-buttons></kendo-pager-next-buttons>
            </div>
          </ng-template>
          <ng-template kendoGridToolbarTemplate>
            <div class="k-grid-toolbar-content d-flex justify-content-end">
              <div class="pagination-container">
                <button class="btn btn-primary" (click)="AddNewData('Elements-Configure')">Add</button>
              </div>
              <div class="icon-wrap" style="margin-left: 1%;">
                <i class="fa fa-filter" style="float: right;font-size: 18px;" title="Filter" (click)="toggleFilter('element')"
                  aria-hidden="true"></i>           
              </div>
            </div>
          </ng-template>
          <kendo-grid-column title="SL No" field="index" width="150">
            <!-- <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              {{rowIndex + 1}}
            </ng-template> -->
          </kendo-grid-column>
          <kendo-grid-column title="Discipline" field="deD_Description" width="150">
          </kendo-grid-column>
          <kendo-grid-column title="Element" field="tE_Description" width="150">
          </kendo-grid-column>
          <kendo-grid-column title="Active Status" field="active_Tag" width="150">
          </kendo-grid-column>
          <kendo-grid-column title="Action" width="80" class="text-center">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <div #divIcon class=" icon-container d-flex align-items-center">
                <i class="fa fa-pencil" title="Edit" (click)="editHandler('Elements-Configure',dataItem)"></i>               
              </div>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </div>
      <!-- </div> -->
    </mat-tab>

    <mat-tab class="mat-tab-label-content" label="Item-Configure">
      <div>
        <kendo-grid [kendoGridBinding]="ItemProjectlink" [sortable]="true" [resizable]="true"
          [filterable]="IC_enableFilter" [reorderable]="true" [pageSize]="15" [pageable]="true">
          <ng-template kendoPagerTemplate> 
            <div class="k-pager-left">
              <kendo-pager-info></kendo-pager-info>
            </div>
            <div class="k-pager-right">
              <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
              <kendo-pager-input></kendo-pager-input>
              <kendo-pager-next-buttons></kendo-pager-next-buttons>
            </div>
          </ng-template>
          <ng-template kendoGridToolbarTemplate>
            <div class="k-grid-toolbar-content d-flex justify-content-end">
              <div class="pagination-container">
                <button class="btn btn-primary" (click)="AddNewData('Item-Configure')">Add</button>
              </div>
              <div class="icon-wrap" style="margin-left: 1%;">
                <i class="fa fa-filter" style="float: right;font-size: 18px;" title="Filter" (click)="toggleFilter('items')"
                  aria-hidden="true"></i>           
              </div>
            </div>            
          </ng-template>
          <kendo-grid-column title="SL No" field="index" width="150">
            <!-- <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              {{rowIndex + 1}}
            </ng-template> --> 
          </kendo-grid-column>
          <kendo-grid-column title="Discipline" field="deD_Description" width="150">
          </kendo-grid-column>
          <kendo-grid-column title="Element" field="tE_Description" width="150">
          </kendo-grid-column>
          <kendo-grid-column title="Items" field="tI_Description" width="150">
          </kendo-grid-column>
          <kendo-grid-column title="Active Status" field="active_Tag" width="150">
          </kendo-grid-column>
          <kendo-grid-column title="Action" width="80" class="text-center">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <div #divIcon class=" icon-container d-flex align-items-center">
                <i class="fa fa-pencil" title="Edit" (click)="editHandler('Item-Configure',dataItem)"></i>                
              </div>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </div>
    </mat-tab>

    <mat-tab class="mat-tab-label-content" label="Tender Quantity">
      <div class="">
        <div class="row eip-pt-20">
          <div style="margin-left: 1%;" *ngIf="ApproveBtn" class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-9">
            <EIPAutoComplete TextField="memberName" ValueField="memberId" WaterMarkText="Approved By *"
              ShowTextValueField='N' [clearValue]='setclear' [dataSource]='approverList' [IsCascading]='true'
              [defaultValue]="selectedAuthorisedBy" (valueChange)='setRevisionValues($event)'
              [selectedIndex]="approverIndex" required>
            </EIPAutoComplete>
            <mat-error>

            </mat-error>
          </div>
          <div class="col-xl-9 col-lg-9 col-md-9 col-sm-12 col-xs-12">
            <dynamic-form #docSetForm [repeatCount]=3> </dynamic-form>
          </div>

          <div class="eip-pr-20 adv-srch-btns eip-ml-auto eip-mt-10" style="margin-bottom: 1%;">
            <input type="submit" value="View" (click)="viewSubBtn()" class="btn btn-primary" id="BtnClear">
            <input type="submit" *ngIf="SubmitBtn" value="Submit" (click)="addTender('submit')"
              class="btn btn-primary eip-ml-20" id="BtnSaveSearch">
            <input type="submit" *ngIf="ApproveBtn" value="Approve" (click)="addTender('approve')"
              class="btn btn-primary eip-ml-20" id="btnSearch">
            <input type="submit" *ngIf="ReviseBtn" value="Revise" (click)="resetAddControl()"
              class="btn btn-primary eip-ml-20" id="btnSearch">
          </div>
        </div>
        <div class="row eip-pt-20" *ngIf="AddBtn">
          <div style="margin-left: 1%;" class="col-md-3 col-xs-3 col-sm-3 col-3" *ngFor="let element of elementsList">
            <EIPAutoComplete [dataSource]='element.items' [clearValue]='setclear' ShowTextValueField='N'
              [setId]="element.tE_Id" TextField="tI_Description"  ValueField="tI_Id" [IsCascading]='true'
              [IsDisabled]="setDisable" WaterMarkText='{{element.tE_Description}}'
              (valueChange)='onValueChange($event,element)' required>
            </EIPAutoComplete>
          </div>
          <div style="margin-left: 1%;" class="col-md-3 col-xs-3 col-sm-3 col-3">
            <input type="number" (keypress)="numberOnly($event)" name="Quantity"
              style="border-bottom: 1px solid; margin-top: 4%;" placeholder="Quantity" [(ngModel)]="quantity" matInput>
          </div>

          <div class="eip-pr-20 adv-srch-btns eip-ml-auto eip-mt-10"
            style="width:100%; clear: both; margin-bottom: 1%;display: inline-block;">
            <div *ngIf="AddBtn" style="width: 100%;">
              <button style="margin-left: 1%; float:right" class="btn btn-primary" (click)="addTender('add')"
                id="BtnClear">Add </button>
            </div>
          </div>
        </div>
        <div >
          <form novalidate #myForm="ngForm">
            <kendo-grid [kendoGridBinding]="tenderlist" [reorderable]="true" [sortable]="true" [resizable]="true"
              [scrollable]="true" (cancel)="cancelHandler($event)" (edit)="editRowData($event)"
              (save)="UpdateRowData($event)" (remove)="deleteRowData($event)" [filterable]="false"
              [pageSize]="15" [pageable]="true">
              <ng-template kendoPagerTemplate>
                <div class="k-pager-left">
                  <kendo-pager-info></kendo-pager-info>
                </div>
                <div class="k-pager-right">
                  <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                  <kendo-pager-input></kendo-pager-input>
                  <kendo-pager-next-buttons></kendo-pager-next-buttons>
                </div>
              </ng-template>
              <kendo-grid-column *ngFor="let stage of elementsList" title="{{stage.tE_Description}}" width="150">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <span [innerHTML]="getItemData(dataItem,stage)"></span>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Quantity" width="170">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <span [innerHTML]="dataItem.tenderElementDetails[0].quantity"></span>
                </ng-template>
                <ng-template kendoGridEditTemplate let-column="column" let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <mat-form-field>
                    <input matInput type="number" [(ngModel)]="updateQuantity" name="quantity"
                      (keypress)="numberOnly($event)">
                  </mat-form-field>
                </ng-template>

              </kendo-grid-column>
              <kendo-grid-column *ngIf="SubmitBtn" title="Status" width="170">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <span [innerHTML]="dataItem.tenderElementDetails[0].submitted_Status"></span>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column *ngIf="ApproveBtn" title="Status" width="170">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <span [innerHTML]="dataItem.tenderElementDetails[0].approval_Status"></span>
                </ng-template>
              </kendo-grid-column>
              <!-- <kendo-grid-column *ngIf="ApproveBtn != true && ReviseBtn != true" title="Action" width="80" class="text-center">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <div #divIcon class=" icon-container d-flex align-items-center">
                    <i class="fa fa-pencil" *ngIf="dataItem.tenderElementDetails[0].approval_Status != 'Approved'"  title="Edit"></i>
                    <i class="fa fa-trash" *ngIf="dataItem.tenderElementDetails[0].approval_Status != 'Approved'" title="Control not Added"></i>
                  </div>
                </ng-template>                
              </kendo-grid-column> -->
              <kendo-grid-column *ngIf="ApproveBtn != true && ReviseBtn != true" title="Action" width="100"  >
                <ng-template kendoGridCellTemplate let-isNew="isNew">
                  <span kendoGridEditCommand class="setEditIcon">
                    <i class="fa fa-pencil" title="Edit"></i>
                  </span>
                  <span kendoGridRemoveCommand class="setSaveIcon">
                    <i class="fa fa-trash"   title="Delete"></i>
                  </span>
                  <span kendoGridSaveCommand class="setEditIcon">
                    <i class="fa fa-save" title="Update"></i>
                  </span>
                  <span kendoGridCancelCommand class="setSaveIcon">
                    <i class="fa fa-cancel" title="Cancel"></i>
                  </span>
                </ng-template>
              </kendo-grid-column>
            </kendo-grid>
          </form>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>